import React from 'react';
import { Box, Typography } from '@material-ui/core';

import { THeader } from '@components';
import { MobileStyledHeader, StyledHeader } from './header.styled';

import { useTheme } from '@material-ui/core/styles';
import { useSSRMediaQuery } from '@helpers';

export function Header({ title, subtitle }: THeader) {
    const theme = useTheme();
    const isSmallScreen = useSSRMediaQuery(theme.breakpoints.down('sm'));

    // Skip rendering until session is hydrated to avoid incorrect layout flashes
    if (isSmallScreen === undefined) {
        return <></>;
    }

    return (
        <div>
            {isSmallScreen ? (
                <MobileStyledHeader>
                    <Box py={1} px={2} textAlign="center">
                        <Typography variant="subtitle2">
                            {title} - {subtitle}
                        </Typography>
                    </Box>
                </MobileStyledHeader>
            ) : (
                <StyledHeader>
                    <Box py={2} px={4} textAlign="center">
                        <Typography variant="subtitle2">{title}</Typography>
                        <Typography variant="h4">{subtitle}</Typography>
                    </Box>
                </StyledHeader>
            )}
        </div>
    );
}
